var render = function () {
  var _vm$event$config$imag;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "background-color": "#f4edf4",
      "height": "100vh",
      "width": "100vw"
    }
  }, [_vm.displayLoading ? _c('loading') : _vm._e(), _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": (_vm$event$config$imag = _vm.event.config.images) === null || _vm$event$config$imag === void 0 ? void 0 : _vm$event$config$imag.landing_kv,
      "alt": ""
    },
    on: {
      "click": function click() {
        return _vm.goto();
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }